import { Observable } from '@logz-pkg/observable';

export class ConfirmLeaveChangesStateService {
  readonly onBeforeUnsubscriber = new Observable<Function>(() => {});
  readonly shouldConfirm = new Observable<boolean>(false);

  setOnBeforeUnsubscribe = (value: Function) => this.onBeforeUnsubscriber.set(value);

  onBeforeUnsubscribe = () => {
    const unsubscriber = this.onBeforeUnsubscriber.get();

    if (unsubscriber) {
      this.onBeforeUnsubscriber.set(() => {});
      unsubscriber();
    }
  };

  getShouldConfirm = () => this.shouldConfirm.get();

  setShouldConfirm = (value: boolean) => this.shouldConfirm.set(value);
}

export const confirmLeaveChangesStateService = new ConfirmLeaveChangesStateService();
